'use client';

// eslint-disable-next-line @alltrails/custom/client-navigation
import { useParams } from 'next/navigation';
import type Locale from '@alltrails/core/types/Locale';
import { getLanguageRegionCodeFromLocale } from '@alltrails/shared/utils/languageSupport';
import useRouter from '@alltrails/core/hooks/useRouter';
import type { LanguageRegionCode } from '@alltrails/core/types/LanguageRegionCode';

type Params = {
  locale: Locale;
};

export function useLanguageRegionCode(): LanguageRegionCode {
  const router = useRouter();
  const params = useParams<Params>();

  const locale = router ? (router.locale as Locale) : params?.locale;

  return getLanguageRegionCodeFromLocale(locale) || 'en-US';
}
